import { useSuspenseQuery } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { apiClient } from '@/_shared';

import type { SystemUserQuerySchema } from '../system-users/shared';
import { parseCustomSettingValue } from '../system-users/shared/custom-settings/api';
import type { CustomSettingsQuerySchema } from '../system-users/shared/custom-settings/schemas/custom-settings-query-schema';

export function useGetCurrentUser() {
  return useSuspenseQuery({
    queryKey: ['CURRENT_USER'],
    queryFn: async () => {
      const res = await apiClient.get<SystemUserQuerySchema>({
        endpoint: `/api/user`,
        params: {
          include: 'country,roles.permissions,custom_settings,team_member.profile_image',
        },
      });
      if (res === null) {
        throw redirect({ to: '/login' });
      }
      const customSettingsRaw = res.custom_settings || [];
      const userSettings = customSettingsRaw
        .filter((setting) => setting.user_id === res.id)
        .map((setting) => ({
          ...setting,
          value: parseCustomSettingValue(setting.value),
        }))
        .filter((setting) => setting.value !== null) as CustomSettingsQuerySchema[];

      return { ...res, custom_settings: userSettings };
    },
  });
}

// const roles = [
//   {
//     id: 1,
//     name: 'Project Manager',
//     azure_role_id: null,
//     created_at: '2025-05-09 12:35:48',
//     updated_at: '2025-05-09 12:35:48',
//     deleted_at: null,
//     pivot: {
//       user_id: 10,
//       role_id: 1,
//       created_at: '2025-05-10T09:16:01.000000Z',
//       updated_at: '2025-05-10T09:16:01.000000Z',
//     },
//     permissions: [
//       {
//         id: 13,
//         role_id: 1,
//         action: 'create',
//         resource_type: 'model',
//         resource: 'inventory',
//         created_at: '2025-05-09 12:35:51',
//         updated_at: '2025-05-09 12:35:51',
//         deleted_at: null,
//       },
//       {
//         id: 24,
//         role_id: 1,
//         action: 'view',
//         resource_type: 'tab',
//         resource: 'contact/api-integration',
//         created_at: '2025-05-10 09:17:18',
//         updated_at: '2025-05-10 09:17:18',
//         deleted_at: null,
//       },
//       {
//         id: 25,
//         role_id: 1,
//         action: 'create',
//         resource_type: 'tab',
//         resource: 'contact/api-integration',
//         created_at: '2025-05-10 09:17:18',
//         updated_at: '2025-05-10 09:17:18',
//         deleted_at: null,
//       },
//       {
//         id: 26,
//         role_id: 1,
//         action: 'update',
//         resource_type: 'tab',
//         resource: 'contact/api-integration',
//         created_at: '2025-05-10 09:17:18',
//         updated_at: '2025-05-10 09:17:18',
//         deleted_at: null,
//       },
//       {
//         id: 27,
//         role_id: 1,
//         action: 'view',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:18:00',
//         updated_at: '2025-05-10 09:18:00',
//         deleted_at: null,
//       },
//       {
//         id: 28,
//         role_id: 1,
//         action: 'create',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:18:00',
//         updated_at: '2025-05-10 09:18:00',
//         deleted_at: null,
//       },
//       {
//         id: 29,
//         role_id: 1,
//         action: 'update',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:18:00',
//         updated_at: '2025-05-10 09:18:00',
//         deleted_at: null,
//       },
//       {
//         id: 30,
//         role_id: 1,
//         action: 'view',
//         resource_type: 'model',
//         resource: 'contact',
//         created_at: '2025-05-10 09:18:44',
//         updated_at: '2025-05-10 09:18:44',
//         deleted_at: null,
//       },
//       {
//         id: 31,
//         role_id: 1,
//         action: 'create',
//         resource_type: 'model',
//         resource: 'contact',
//         created_at: '2025-05-10 09:18:44',
//         updated_at: '2025-05-10 09:18:44',
//         deleted_at: null,
//       },
//       {
//         id: 32,
//         role_id: 1,
//         action: 'update',
//         resource_type: 'model',
//         resource: 'contact',
//         created_at: '2025-05-10 09:18:44',
//         updated_at: '2025-05-10 09:18:44',
//         deleted_at: null,
//       },
//     ],
//   },
//   {
//     id: 2,
//     name: 'Sales Manager',
//     azure_role_id: null,
//     permissions: [
//       {
//         id: 14,
//         role_id: 2,
//         action: 'create',
//         resource_type: 'model',
//         resource: 'inventory',
//         created_at: '2025-05-09 14:39:55',
//         updated_at: '2025-05-09 14:39:55',
//         deleted_at: null,
//       },
//       {
//         id: 15,
//         role_id: 2,
//         action: 'view',
//         resource_type: 'model',
//         resource: 'client',
//         created_at: '2025-05-10 09:06:19',
//         updated_at: '2025-05-10 09:06:19',
//         deleted_at: null,
//       },
//       {
//         id: 16,
//         role_id: 2,
//         action: 'create',
//         resource_type: 'model',
//         resource: 'client',
//         created_at: '2025-05-10 09:06:19',
//         updated_at: '2025-05-10 09:06:19',
//         deleted_at: null,
//       },
//       {
//         id: 17,
//         role_id: 2,
//         action: 'update',
//         resource_type: 'model',
//         resource: 'client',
//         created_at: '2025-05-10 09:06:19',
//         updated_at: '2025-05-10 09:06:19',
//         deleted_at: null,
//       },
//       {
//         id: 18,
//         role_id: 2,
//         action: 'view',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:07:02',
//         updated_at: '2025-05-10 09:07:02',
//         deleted_at: null,
//       },
//       {
//         id: 19,
//         role_id: 2,
//         action: 'create',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:07:02',
//         updated_at: '2025-05-10 09:07:02',
//         deleted_at: null,
//       },
//       {
//         id: 20,
//         role_id: 2,
//         action: 'update',
//         resource_type: 'widget',
//         resource: 'recent_contacts',
//         created_at: '2025-05-10 09:07:02',
//         updated_at: '2025-05-10 09:07:02',
//         deleted_at: null,
//       },
//       {
//         id: 21,
//         role_id: 2,
//         action: 'view',
//         resource_type: 'tab',
//         resource: 'contact/agreements',
//         created_at: '2025-05-10 09:07:45',
//         updated_at: '2025-05-10 09:07:45',
//         deleted_at: null,
//       },
//       {
//         id: 22,
//         role_id: 2,
//         action: 'create',
//         resource_type: 'tab',
//         resource: 'contact/agreements',
//         created_at: '2025-05-10 09:07:45',
//         updated_at: '2025-05-10 09:14:11',
//         deleted_at: null,
//       },
//       {
//         id: 23,
//         role_id: 2,
//         action: 'update',
//         resource_type: 'tab',
//         resource: 'contact/agreements',
//       },
//     ],
//   },
// ] as unknown as UserQuerySchema['roles'];
